"use strict";
export default {
  strategyForField(field) {
    switch (field.visibility_strategy) {
      case "ltl_load_only":
        return (load) => load && load.mode && load.mode === "LTL";
        break;
      default:
        return () => true;
        break;
    }
  }
};
